<div class="lg:tw-block tw-hidden">
  <sb-progressbar [bigProgress]="false"
                  [width]="dateTransformation.getTimeframePercentage(campaignOrCommercial?.from,campaignOrCommercial?.till)"
                  mode="progressBar">
    <div class="tw-flex tw-items-center">
      <ng-container *ngTemplateOutlet="timingStatusDisplay"></ng-container>
    </div>

  </sb-progressbar>
  <ng-container *ngTemplateOutlet="fromTillTooltip"></ng-container>
</div>

<sb-progressbar class="lg:tw-hidden tw-block" [ngbTooltip]="fromTillTooltip" placement="top" [bigProgress]="false"
                [width]="dateTransformation.getTimeframePercentage(campaignOrCommercial?.from,campaignOrCommercial?.till)"
                mode="progressBar" container="body">
  <ng-container *ngTemplateOutlet="timingStatusDisplay"></ng-container>
</sb-progressbar>

<ng-template #fromTillTooltip>
  @if (campaignOrCommercial?.from && campaignOrCommercial?.till) {

    <div class="tw-flex tw-justify-between tw-flex-nowrap tw-text-sm">
                    <span class="text-start">
                      {{ campaignOrCommercial?.from?.toString() | date: 'dd.MM.yy HH:mm' }}
                    </span>
      <span class="tw-mx-1">-</span>
      <span class="text-end">
      {{ campaignOrCommercial?.till?.toString() | date: 'dd.MM.yy HH:mm' }}
    </span>
  </div>
  } @else {
    <span class="tw-text-sm">{{ 'lang.globals.noTiming' | translate }}</span>

  }
</ng-template>

<ng-template #timingStatusDisplay>
  @switch (campaignOrCommercial.timingStatus) {
    @case ('Future') {
      <span class="tw-text-sbYellow-600 tw-font-semibold">{{ 'lang.globals.planned' | translate }}</span>
    }
    @case ('Present') {
      <span class="tw-text-sbGreen-600 tw-font-semibold">{{ 'lang.globals.running' | translate }}</span>
    }
    @case ('Past') {
      <span class="tw-font-semibold">{{ 'lang.globals.expired' | translate }}</span>
    }
    @case ('Unknown') {
      <span class="tw-font-semibold">{{ 'lang.globals.unknown' | translate }}</span>
    }
  }
</ng-template>
